import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getMindfile } from './../../../../state/actions/getDataActions'
import { Link } from 'react-router-dom'
import { withStyles } from "@mui/styles";
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import { Box } from '@mui/material';
import MindfileBar from '../mindfile-bar/MindfileBar';

const styles = theme => ({
  appBar: {
    color: '#002f43',
    backgroundImage: 'radial-gradient(circle at 30%, white, #C2C2C2, #C2C2C2)',
  },
  grow: {
    flexGrow: 1,
  },
  logo: {
    height: 24,
  },
  menuButton: {

  },
  toolbar:{
    '& > *':{
      height:'64px',
      boxSizing:'border-box'
    }
  }
})

class MainAppBar extends Component {
  state = {
  }

  render() {
    const { classes } = this.props
    return (
      <AppBar id="appBarMain" position="static" className={classes.appBar}>
        <Toolbar>
          <div className={classes.grow}>
            <MindfileBar />
          </div>
          <Box className={classes.toolbar} sx={{ display: { xs: 'none', md: 'block' } }} >
            <Button color="inherit" component={Link} to='/explore'>Explore</Button>
            {/*<Button color="inherit" component={Link} to='/profile'>Profile</Button>*/}
            {this.props.isCurrentMindfileOwner
              ? <Button color="inherit" component={Link} to='/social'>Social</Button>
              : null
            }
            <Button color="inherit" component={Link} to='/spacecast'>Spacecast</Button>
            {this.props.user.is_admin ? <Button color="inherit" component={Link} to='/admin'>Admin</Button> : null}
            {this.props.isCurrentMindfileOwner
              ? <Button color="inherit" component={Link} to='/settings'>Settings</Button>
              : this.props.isCurrentMindfileContributor
                ? <Button color="inherit" component={Link} to='/contributor-settings'>Settings</Button>
                : null}
            <Button color="inherit" href="#help_load">Help</Button>
            <Button color="inherit" onClick={this.props.openContactDialog}>Contact</Button>
            <Button color="inherit" component={Link} to='/logout'>Logout</Button>
          </Box>
          <Box className={classes.toolbar} sx={{ display: { xs: 'block', md: 'none' } }} >
            <IconButton color="inherit" onClick={this.props.toggleRightDrawer} className={classes.menuButton}>
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
    )
  }
}

const mapStateToProps = state => ({
  user: state.auth,
  isCurrentMindfileOwner: state.isCurrentMindfileOwner,
  isCurrentMindfileContributor: state.isCurrentMindfileContributor,
  mindfile: state.mindfile,
})

const mapDispatchToProps = {
  getMindfile
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MainAppBar))
